import * as types from '../constants/tradepanelConstants';
import * as insttypes from '../constants/instrumentListConstants';
import * as dashboardTypes from '../constants/dashboardConstants';
import * as commonType from '../constants/commonConstants';
import * as activitType from '../constants/activityConstants';
import * as instAction from '../actions/instrumentListActions';
import * as instType from '../constants/instrumentListConstants';
import * as newsFeed from '../constants/newsFeedConstants';
import * as authTypes from '../redux/modules/auth'
import * as dashboardActions from '../actions/dashboardActions';
import { getPath } from '../actions/commonActions';
import appConstants from '../appConstants'
import Socket from '../utils/socket';
import { unformatLang } from './../utils/utils';
import i18next from 'i18next';


let orderWebsocket;
let orderSocket;
let connectionOpen = false;
let closedFromClient = false;

export function clearHeartOrdInterval() {
  orderSocket && orderSocket.resetSocket();
  return {
    type: instType.SUBSCRIBE_TIER,
  }
}

export function updateStatus() {
  return {
    type: insttypes.UPDATE_STATUS
  };
}

export function updateCustMargin(msg) {
  return {
    type: instType.UPDATE_MARGIN_PERC,
    msg
  };
}

export function setTradingstatus(status) {
  return {
    type: types.TRD_STATUS,
    status
  };
}

export function killSessionTrader(msg, flag) {
  const key = true;
  clearHeartOrdInterval();
  if (flag !== true) {
    localStorage.setItem('user', null);
  }
  localStorage.setItem('userlogin', null);
  localStorage.setItem('logoutClose', 'true');
  instAction.resetStateSocket();
  instAction.closeSocketData();
  return {
    type: commonType.KILL_SESSION,
    key, msg, flag
  };
}

export function sessionReset() {
  localStorage.setItem('logoutClose', 'true');
  clearHeartOrdInterval();
  instAction.closeSocketData();
  closeSocketTrade();
  return {
    type: insttypes.SUBSCRIBE_TIER,//this type does nothing hnce used
  };
}

export function killlogout() {
  localStorage.setItem('logoutClose', 'true');
  // instAction.closeSocketData();
  closeSocketTrade();
}

export function tradeMasterChnage(msg) {
  try {
    var TS = {};
    TS = JSON.parse(localStorage.getItem('TS'));
    if(msg.ACD){
      TS.ACD = msg.ACD
    }
    localStorage.setItem('TS', JSON.stringify(TS));
    return {
      type: commonType.FORCED_LOGOUT
    };

  } catch (e) { console.log(e); }
}

export function tradeAccMasterMTChnage(msg) {
  try {
    return {
      type: commonType.FORCED_LOGOUT
    };

  } catch (e) { console.log(e); }
}

export function actLogRmkGenerator(msg) {
  return {
    type: activitType.UPDATE_ACTIVITYCOMPONENT,
    msg
  }
}

export function physicalDeliveryActivityUpdate(msg) {
  return {
    type: activitType.UPDATE_PHYSICAL_DELIVERY_ACTIVITY,
    msg
  }
}

export function physicalDeliveryDataUpdate(msg) {
  return {
    type: commonType.UPDATE_PHYSICAL_DELIVERY_DATA,
    msg
  }
}

export function updateAccountBalance(msg) {
  return {
    type: instType.UPDATE_ACCBAL,
    msg
  };
}

export function updateStock(msg) {
  return {
    type: instType.UPDATE_INST,
    msg
  };
}

export function updateNewsFeedData(message) {
  return {
    type: newsFeed.UPDATE_NEWSFEED,
    message
  };
}

export function getBenchMark() {
  return {
    type: types.GETBM,
    promise: (client) => client.get('/GetValidBenchmarksTrd', {})
  };
}

// Updating socket data for trade
export function updateTradeSocketData(message) {
  return {
    type: types.UPDATE_TRADE_SOCKET_DATA,
    message
  };
}

export function updateValueDate(message) {
  return {
    type: instType.UPDATE_VALUEDATE,
    message
  };
}

export function updateBenchmark(message) {
  return {
    type: types.CUTOFF_BENCHMARK,
    message
  };
}

export function editBenchmark(message) {
  return {
    type: types.UPDATE_BM_LIST,
    message
  };
}

export function updateShowPrice(message) {
  return {
    type: authTypes.UPDATE_SHOWPRICE,
    message
  };
}

export function updateStkMarkup(message) {
  return {
    type: insttypes.UPDATE_STK_MARKUP,
    message
  };
}

export function updateStkMaster(message) {
  return {
    type: insttypes.UPDATE_STK_MASTER,
    message
  };
}

export function updateStatusChng(message) {
  return {
    type: types.UPDATE_STATUS_CHANGE,
    message
  };
}

export function updateOP(msg) {
  return {
    type: insttypes.OPEN_TRADE,
    msg
  };
}

export function closeAlert() {
  return {
    type: types.HIDE_ALERT,
  };
}

export function showAlert(msg) {
  return {
    type: types.SHOW_ALERT,
    msg
  };
}

export function sucessOrderTrade() {
  return (dispatch) => {
    dispatch({
      type: types.ORDER_SUCCESS
    });
  };
}

// To show trade execution, coming through web socket
export function sucessExecuteTrade(data) {
  return (dispatch) => {
    dispatch({
      type: types.EXECUTE_SUCCESS,
      data
    });
  };
}

export function updateCanTrade(message) {
  return {
    type: authTypes.TRADING_DISABLE,
    message
  };
}

export function accChange(message) {
  return {
    type: authTypes.ACC_CHANGE,
    message
  };
}

export function updateOrderStatus() {
  return {
    type: types.UPDATE_ORDER_STATUS
  };
}

export function sessionTimeout() {
  return (dispatch) => {
    dispatch({
      type: dashboardTypes.SESSION_TIMEOUT,
    });
  };
}

// function to be called for sending HB
function sendHeartbeat(ws) {
  const USER = JSON.parse(localStorage.getItem('user'));
  let obj = {};
  obj.MT = "HEARTBEAT";
  obj.SID = USER.SID;
  ws.send(JSON.stringify(obj));
  connectionOpen = true;
}

// function to be called after opening
function callOnOpening() {
  return [
    sendHeartbeat
  ];
}

function getWSMessage (msg) {
  return {
    type: types.GET_WS_MESSAGE,
    msg
  };
}

// function to be called after receiving messages
function callOnMessage(dispatch, event) {
  const msg = JSON.parse(event.data);
  dispatch(getWSMessage(msg))
  // handle different types of BCM
  switch (msg.BCM) {
    case appConstants.ACC_BAL_UPDATE:
      dispatch(updateAccountBalance(msg));
      break;
    case appConstants.MSG_TO_TRD:
      dispatch(showAlert(msg));
      break;
    case appConstants.UPDATE_STOCK:
      dispatch(updateStock(msg));
      break;
    case appConstants.UPDATE_CUST_MARGIN:
      dispatch(authTypes.handleAcdDataUpdate(msg))
      dispatch(updateCustMargin(msg));
      break;
    case appConstants.TRD_MASTER_CNG:
      localStorage.setItem('logoutClose', 'true');
      clearHeartOrdInterval();
      dispatch(tradeMasterChnage(msg));
      break;
    case appConstants.NEWS_FEED:
      dispatch(updateNewsFeedData(msg));
      break;
    case appConstants.KILL_TRD_SES:
      localStorage.setItem('logoutClose', 'true');
      dispatch(killSessionTrader(i18next.t('sessionKillByDealerMsg'), false));
      dispatch(dashboardActions.loadTemplateFlag(false));
      killlogout();
      break;
    case appConstants.FORCED_LOGOUT:
      localStorage.setItem('logoutClose', 'true');
      dispatch(killSessionTrader(i18next.t('sessionTerminateMsg'), false));
      dispatch(dashboardActions.loadTemplateFlag(false));
      killlogout();
      break;
    case appConstants.ACC_MT_CHANGE_LOGOUT:
      localStorage.setItem('logoutClose', 'true');
      clearHeartOrdInterval();
      dispatch(tradeAccMasterMTChnage(msg));
      break;
    case appConstants.TRADING_STATUS_CHANGED:
      dispatch(setTradingstatus(msg));
      break;
    case appConstants.END_OF_DAY:
      localStorage.setItem('logoutClose', 'true');
      dispatch(killSessionTrader(i18next.t('tradingSessionEndMsg'), false));
      dispatch(dashboardActions.loadTemplateFlag(false));
      killlogout();
      break;
    case appConstants.UPDATE_VALUE_DATE:
      dispatch(updateValueDate(msg));
      break;
    case appConstants.BENCHMARK_CUTOFF:
      dispatch(updateBenchmark(msg));
      break;
    case appConstants.UPDATE_BMDETAILS:
      dispatch(editBenchmark(msg));
      break;
    case appConstants.UPDATE_SHOWPRICE:
      dispatch(updateShowPrice(msg));
      break;
    case appConstants.UPDATE_STKCODE_MARKUP:
      dispatch(updateStkMarkup(msg));
      break;
    case appConstants.UPDATE_STOCK_MASTER:
      dispatch(updateStkMaster(msg));
      break;
    case appConstants.CONN_STATUS_CHANGE:
      dispatch(updateStatusChng(msg));
      break;
    case appConstants.ACC_CHANGE:
      dispatch(accChange(msg));
      break;
    case appConstants.OPEN_TRADE:
      dispatch(updateOP(msg));
      break;
    case appConstants.TRADING_DISABLE:
      dispatch(updateCanTrade(msg));
      break;
    case appConstants.WS_RECONNECT:
      dispatch(reconnectSocketCon());
      break;
    case appConstants.INVALID_OPEN_TRADE_REQUEST:
      dispatch(displayAlertForOpenTrade(msg));
      break;
    case appConstants.PHYSICAL_DELIVERY_REQUEST_PLACED:
    case appConstants.PHYSICAL_DELIVERY_REQUEST_RECEIVED:
    case appConstants.PHYSICAL_DELIVERY_REQUEST_CANCELLED:
    case appConstants.PHYSICAL_DELIVERY_DELIVERED:
    case appConstants.PHYSICAL_DELIVERY_MARGIN_CHECKS_FAIL:
      dispatch(physicalDeliveryActivityUpdate(msg))
      dispatch(physicalDeliveryDataUpdate(msg))
      break;  
    default:
      if ((msg.IID) !== undefined) {
        dispatch(actLogRmkGenerator(msg));
      }
      break;
    }
}

export function displayAlertForOpenTrade(message){
  let flag= true;
  return{
    type:activitType.SHOW_OPENTRADE_ALERT,
    flag,message
  }
}

// function to be called after disconnection
function callOnDisconnect(dispatch) {
  dispatch(updateOrderStatus());
  dispatch(clearHeartOrdInterval());
  dispatch(killSessionTrader(i18next.t("sessionExpired"), false));
  killlogout();
}

// functions to be called after rate and order reconnection
function callOnReconnect(dispatch) {
  connectionOpen = false;
  dispatch(updateOrderStatus());
}

// new socket connection logic
export function loadSocketTrade(dispatch) {
  // need to declare constants here to get non-null values
  const USER = JSON.parse(localStorage.getItem('user'));
  const PLATFORM = localStorage.getItem('platform');

  // check if user data exists
  if (USER === null) {
    dispatch(sessionTimeout());
  } else {
    // establish websocket connection
    orderSocket = new Socket();
    const orderWSParams = {
      url: getPath('order') + '/order/trader',
      params: [
        "neo-ws-protocol",
        "UID|" + USER.UID,
        "platform|" + PLATFORM,
        "SID|" + USER.SID,
        "CID|" + USER.location
      ]
    };
    orderWebsocket = orderSocket.connectSocket(orderWSParams, dispatch, callOnOpening, callOnMessage, callOnDisconnect, callOnReconnect);
  }
}

// Load socket data for trade
export function loadSocketTradeData() {
  return (dispatch) => {
    dispatch({
      type: types.LOAD_TRADE_SOCKET_DATA,
      socketData: loadSocketTrade(dispatch)
    });
  };
}

export function reconnectSocketCon() {
  if (orderWebsocket) {
    orderWebsocket.close();
  }
  connectionOpen = false;
  instAction.reconnectRateSocketCon();
  loadSocketTrade();
}

export function closeSocketConTrade() {
  if (orderWebsocket) {
    closedFromClient = true;
    orderWebsocket.close();
  }
}

// Closing web socket if trade inProgress
export function closeWebSocketTrade() {
  return {
    type: types.CLOSE_WEBSOCKET_TRADE,
  };
}
// Closing socket data for trade
export function closeSocketTrade() {
  return {
    type: types.CLOSE_SOCKET_TRADE,
    socketData: closeSocketConTrade()
  };
}
// Handle sell or buy operation on trade panel
export function handleSellBuyOrder(QT, CmdtyPair, Quantity, Measure, DealType, price, OrderType, OMT, PCT, Remark, Validty, CTID, baseRate, baseInstId, tempTS) {
  return {
    type: activitType.GET_TRADE_CTID,
    order: orderSellBuy(QT, CmdtyPair, Quantity, Measure, DealType, price, OrderType, OMT, PCT, Remark, Validty, CTID, baseRate, baseInstId, tempTS),
    ctid: CTID
  };
}

export function orderSellBuy(QT, CmdtyId, Quantity, Measure, DealType, price, OrderType, OMT, PCT, Remark, Validty, CTID, baseRate, baseInstId, tempTS) {
  const user = JSON.parse(localStorage.getItem('user'));
  const AccDet = JSON.parse(localStorage.getItem('DFA'));
  if (user === null) {
    dispatch(sessionTimeout());
  }
  const platform = localStorage.getItem('platform');
  let symbol;
  let priceValue = price;
  let quant = Quantity;
  if (!priceValue) {
    priceValue = 0;
  }
  if (quant === '') {
    quant = 0;
  }

  var obj = {};
  obj.MT = "NEW_ORDER";
  obj.UID = user.UID;
  obj.UCD = user.trdCode;
  obj.UD = user.UD;
  obj.IID = CmdtyId;
  obj.QT = QT;
  obj.PQ = parseFloat(quant);
  obj.DT = DealType;
  obj.R = parseFloat(priceValue);
  obj.OT = OrderType;
  obj.CID = user.location;
  obj.AC = AccDet.C;
  obj.AD = AccDet.D;
  if (Measure === "") {
    obj.SC = "";
  } else {
    obj.SC = Measure;
  }
  obj.OMT = OMT;
  obj.PCT = PCT;
  obj.UUID = user.authToken;
  obj.RMK = Remark;
  obj.CR = priceValue;
  obj.VD = Validty;
  obj.SID = user.SID;
  obj.CTID = CTID;
  obj.MD = -1;
  obj.BSR = baseRate;
  obj.BSIID = baseInstId;
  obj.tempTS = tempTS;
  try {
    if (orderWebsocket && connectionOpen === true) {
      orderWebsocket = orderSocket.getSocket();
      orderWebsocket.send(JSON.stringify(obj));
    } else {
      return (false);
    }
  } catch (e) {
    return (false);
  }
  return true;
}

export function handleSquareOffOrder(orderData) {
  return {
    type: activitType.GET_TRADE_CTID,
    order: orderSquareOff(orderData),
    ctid: orderData.CTID
  };
}

function orderSquareOff(orderData) {
  try {
    if (orderWebsocket && connectionOpen === true) {
      orderWebsocket = orderSocket.getSocket();
      orderWebsocket.send(JSON.stringify(orderData));
    } else {
      return (false);
    }
  } catch (e) {
    return (false);
  }
  return true;
}

// Hide modal
export function modalHide() {
  return {
    type: types.HIDE_MODAL,
  };
}

export function handleSellBuyLMTOrder(CmdtyPair, tempQ, selectedMeasure, DealType, Price, OrderType, OMT, PCT, remark, ValidityType, CTID, datetime, VD, baseInstId) {
  return {
    type: types.ORDER_SUCCESS_TYPE,
    order: orderSellBuyLMT(CmdtyPair, tempQ, selectedMeasure, DealType, Price, OrderType, OMT, PCT, remark, ValidityType, CTID, datetime, VD, baseInstId)
  };
}

function orderSellBuyLMT(CmdtyPair, Quantity, Measure, DealType, Price, OrderType, OMT, PCT, remark, ValidityType, CTID, datetime, VD, baseInstId) {
  const user = JSON.parse(localStorage.getItem('user'));
  const AccDet = JSON.parse(localStorage.getItem('DFA'));
  if (user === null) {
    dispatch(sessionTimeout());
  }
  const platform = localStorage.getItem('platform');
  let symbol;
  let priceValue = Price;
  let quant = Quantity;

  if (!priceValue) {
    priceValue = 0;
  }
  if (quant === '') {
    quant = 0;
  }
  var obj = {};
  obj.MT = "NEW_ORDER";
  obj.UID = user.UID;
  obj.UCD = user.trdCode;
  obj.UD = user.UD;
  obj.IID = CmdtyPair;
  obj.PQ = parseFloat(quant);
  obj.DT = DealType;
  obj.R = parseFloat(Price);
  obj.OT = OrderType;
  obj.CID = user.location;
  obj.AC = AccDet.C;
  obj.AD = AccDet.D;
  if (Measure === "") {
    obj.SC = "";
  } else {
    obj.SC = Measure;
  }
  obj.ST = "";
  obj.OMT = OMT;
  obj.PCT = PCT;
  obj.RMK = remark;
  obj.DRMK = " ";
  obj.MD = -1;
  obj.VD = VD;
  obj.SID = user.SID;
  obj.CTID = CTID;
  obj.VT = ValidityType; //validity, ValidityType class
  obj.OMC = 0;//order modification count
  obj.VTE = datetime;//epoch UTC timestamp
  obj.BSIID = baseInstId
  try {
    if (orderWebsocket && connectionOpen === true) {
      orderWebsocket = orderSocket.getSocket();
      orderWebsocket.send(JSON.stringify(obj));
    }
    else {
      return false;
    }
  } catch (e) {
    return false;
  }
  return true;

}

export function handleModifyLMTOrder(CmdtyPair, tempQ, selectedMeasure, DealType, Price, orderType, OMT, PCT, remark, VT, CTID, datetime, OPQ, OR, OVT, OSC, NOD, BID, PCLD, DRMK, HSE, VD, AC, AD, OTIME) {
  return {
    type: types.ORDER_SUCCESS_TYPE,
    order: orderLMTModify(CmdtyPair, tempQ, selectedMeasure, DealType, Price, orderType, OMT, PCT, remark, VT, CTID, datetime, OPQ, OR, OVT, OSC, NOD, BID, PCLD, DRMK, HSE, VD, AC, AD, OTIME),
  };
}

function orderLMTModify(CmdtyPair, tempQ, Measure, DealType, Price, orderType, OMT, PCT, remark, VT, CTID, datetime, OPQ, OR, OVT, OSC, NOD, BID, PCLD, DRMK, HSE, VD, AC, AD, OTIME) {
  const user = JSON.parse(localStorage.getItem('user'));
  const AccDet = JSON.parse(localStorage.getItem('DefaultAC'));
  if (user === null) {
    dispatch(sessionTimeout());
  }
  const platform = localStorage.getItem('platform');
  let symbol;
  let priceValue = Price;
  let quant = tempQ;
  if (!priceValue) {
    priceValue = 0;
  }
  if (quant === '') {
    quant = 0;
  }

  var obj = {};
  obj.UID = user.UID;
  obj.UCD = user.trdCode;
  obj.UD = user.UD;
  obj.IID = CmdtyPair;
  obj.PQ = parseFloat(quant);
  obj.DT = DealType;
  obj.R = parseFloat(Price);
  obj.OT = orderType;
  obj.CID = user.location;
  obj.AC = AC;
  obj.AD = AD;
  obj.VD = VD;
  if (Measure === "") {
    obj.SC = "";
  } else {
    obj.SC = Measure;
  }
  obj.ST = "";
  obj.OMT = OMT;
  obj.PCT = PCT;
  obj.UUID = user.authToken;
  obj.RMK = remark;
  obj.SID = user.SID;
  obj.CTID = CTID;
  obj.VT = VT; //validity, ValidityType class
  obj.OMC = 1;//order modification count
  obj.VTE = datetime;//epoch UTC timestamp

  obj.OPQ = OPQ; //old PQ
  obj.OR = OR;
  obj.OVT = OVT;
  obj.OSC = OSC;
  obj.NOD = NOD;
  obj.BID = BID;//check if this is needed in new system, can be managed in server
  obj.OTIME = OTIME; //old time for GTD orders
  obj.LM = "admin";
  obj.MD = "-1";
  obj.PCLD = PCLD;
  obj.DRMK = DRMK;
  obj.MT = "MODIFY_ORDER";
  try {
    if (orderWebsocket && connectionOpen === true) {
      orderWebsocket = orderSocket.getSocket();
      orderWebsocket.send(JSON.stringify(obj));
    } else {
      return false;
    }
  } catch (e) {
    return false;
  }
  return true;
}

export function handleCancelledLMT(orderDetailsArray, OMT, PCT, OT) {
  return {
    type: types.ORDER_SUCCESS_TYPE,
    order: orderLMTCancelled(orderDetailsArray, OMT, PCT, OT),
  };
}

function orderLMTCancelled(order, OMT, PCT, OT) {
  const user = JSON.parse(localStorage.getItem('user'));
  const AccDet = JSON.parse(localStorage.getItem('DefaultAC'));
  if (user === null) {
    dispatch(sessionTimeout());
  }
  var Price = unformatLang(order.OR);
  var Qty = unformatLang(order.quantity);
  const platform = localStorage.getItem('platform');
  var obj = {};
  var arr = [];
  obj.SID = user.SID;
  obj.UID = user.UID;
  obj.UCD = user.trdCode;
  obj.UD = user.UD;
  obj.OMT = OMT;
  obj.CID = user.location;
  obj.PCT = PCT;
  obj.AC = order.accCode,
    obj.AD = order.accDescription,
    obj.NOD = order.orderNo,
    // obj.R=currencyFormatter.unformat(order.OR,{locale:navigator.language}),
    // obj.PQ=currencyFormatter.unformat(order.quantity,{locale:navigator.language}),
    obj.R = parseFloat(Price)
  obj.PQ = parseFloat(Qty),
    obj.GQ = order.quantity,
    obj.RMK = order.comments,
    obj.SC = order.OSC, //this is only for metals, for forex this will be blank
    obj.IID = order.cmdtyId,
    obj.BID = order.BID,//check if this is needed in new system, can be managed in server
    obj.DT = order.DT
  obj.VT = order.VT,//validity, ValidityType class
    obj.HSE = 1,
    obj.OT = OT, //In future stop orders might come, so OT inside array
    obj.PCLD = order.id,
    obj.MD = -1;
  obj.CTID = order.CTID,
    obj.MT = "CANCEL_ORDER";

  try {
    if (orderWebsocket && connectionOpen === true) {
      orderWebsocket = orderSocket.getSocket();
      orderWebsocket.send(JSON.stringify(obj));
    } else {
      return false;
    }
  } catch (e) {
    return false;
  }
  return true;
}

export function updatePopoutCount(popoutLimit) {
  return {
    type: types.UPDATE_POPOUT_COUNT,
    popoutLimit
  };
}

export function orderSelectionFunc(flag) {
  return {
    type: activitType.ORDER_SELECTION_SUCCESS_TYPE,
    flag
  };
}


/*------------------- Fixing orders --------------------------------*/
//fixing order placement
export function handleSellBuyFIXOrder(CmdtyPair, tempQ, dealType, Price, fixingDate, CTID, selectedMeasure, remark, ValueDate, selectedFixingCode, selectedFixing, selectedFixingTime, baseInstId) {
  return {
    type: types.ORDER_SUCCESS_TYPE,
    order: orderSellBuyFIX(CmdtyPair, tempQ, dealType, Price, fixingDate, CTID, selectedMeasure, remark, ValueDate, selectedFixingCode, selectedFixing, selectedFixingTime, baseInstId),
  };
}

function orderSellBuyFIX(CmdtyPair, tempQ, dealType, Price, fixingDate, CTID, selectedMeasure, remark, ValueDate, selectedFixingCode, selectedFixing, selectedFixingTime, baseInstId) {
  const user = JSON.parse(localStorage.getItem('user'));
  const AccDet = JSON.parse(localStorage.getItem('DFA'));
  if (user === null) {
    dispatch(sessionTimeout());
  }
  const platform = localStorage.getItem('platform');
  let symbol;
  let priceValue = Price;
  let quant = tempQ;

  if (!priceValue) {
    priceValue = 0;
  }
  if (quant === '') {
    quant = 0;
  }
  var obj = {};
  obj.MT = "NEW_ORDER"
  obj.UID = user.UID
  obj.UD = user.UD
  obj.UCD = user.trdCode
  obj.IID = CmdtyPair
  obj.PQ = parseFloat(quant)
  obj.DT = dealType
  obj.R = parseFloat(priceValue)
  obj.OT = 4
  obj.CID = user.location
  obj.AC = AccDet.C
  obj.AD = AccDet.D
  obj.SC = selectedMeasure
  obj.OMT = 1
  obj.PCT = 19
  obj.RMK = remark
  obj.VD = ValueDate
  obj.SID = user.SID
  obj.FC = selectedFixingCode
  obj.FN = selectedFixing
  obj.FT = selectedFixingTime
  obj.CTID = CTID
  obj.MD = -1
  obj.FD = fixingDate
  obj.BSIID = baseInstId
  //console.log("obj"+JSON.stringify(obj));
  try {
    if (orderWebsocket && connectionOpen === true) {
      orderWebsocket = orderSocket.getSocket();
      orderWebsocket.send(JSON.stringify(obj));
    } else {
      return false;
    }
  } catch (e) {
    return false;
  }
  return true;
}

export function handleModifyFIXOrder(CmdtyPair, tempQ, dealType, Price, fixingDate, CTID, selectedMeasure, remark, ValueDate, selectedFixingCode, selectedFixing, selectedFixingTime, ordNo) {
  return {
    type: types.ORDER_SUCCESS_TYPE,
    order: orderFIXModify(CmdtyPair, tempQ, dealType, Price, fixingDate, CTID, selectedMeasure, remark, ValueDate, selectedFixingCode, selectedFixing, selectedFixingTime, ordNo),
  };
}

function orderFIXModify(CmdtyPair, tempQ, dealType, Price, fixingDate, CTID, selectedMeasure, remark, ValueDate, selectedFixingCode, selectedFixing, selectedFixingTime, ordNo) {
  const user = JSON.parse(localStorage.getItem('user'));
  const AccDet = JSON.parse(localStorage.getItem('DFA'));
  if (user === null) {
    dispatch(sessionTimeout());
  }
  const platform = localStorage.getItem('platform');
  let symbol;
  let priceValue = Price;
  let quant = tempQ;

  if (!priceValue) {
    priceValue = 0;
  }
  if (quant === '') {
    quant = 0;
  }
  var obj = {};
  obj.MT = "MODIFY_ORDER"
  obj.UID = user.UID
  obj.UD = user.UD
  obj.UCD = user.trdCode
  obj.IID = CmdtyPair
  obj.PQ = parseFloat(quant)
  obj.DT = dealType
  obj.R = parseFloat(priceValue)
  obj.OT = 4
  obj.CID = user.location
  obj.AC = AccDet.C
  obj.AD = AccDet.D
  obj.SC = selectedMeasure
  obj.OMT = 2
  obj.PCT = 20
  obj.RMK = remark
  obj.VD = ValueDate
  obj.SID = user.SID
  obj.FC = selectedFixingCode
  obj.FN = selectedFixing
  obj.FT = selectedFixingTime
  obj.CTID = CTID
  obj.MD = -1
  obj.FD = fixingDate
  obj.OrderNo = ordNo
  try {
    if (orderWebsocket && connectionOpen === true) {
      orderWebsocket = orderSocket.getSocket();
      orderWebsocket.send(JSON.stringify(obj));
    } else {
      return false;
    }
  } catch (e) {
    return false;
  }
  return true;
}

export function handleCancelledFIX(orderDetailsArray, fixingDate, Price, Qty) {
  return {
    type: types.ORDER_SUCCESS_TYPE,
    order: orderFIXCancelled(orderDetailsArray, fixingDate, Price, Qty),
  };
}

function orderFIXCancelled(order, fixingDate, Price, Qty) {
  const user = JSON.parse(localStorage.getItem('user'));
  const AccDet = JSON.parse(localStorage.getItem('DFA'));
  if (user === null) {
    dispatch(sessionTimeout());
  }
  const platform = localStorage.getItem('platform');
  var obj = {};
  obj.MT = "CANCEL_ORDER"
  obj.UID = user.UID
  obj.UD = user.UD
  obj.UCD = user.trdCode
  obj.IID = order.cmdtyId
  obj.PQ = Qty,
    obj.DT = order.DT
  //obj.R = Price,
  obj.OT = 4
  obj.CID = user.location
  obj.AC = AccDet.accCode
  obj.AD = AccDet.accDescription
  obj.SC = order.OSC
  obj.OMT = 6
  obj.PCT = 21
  obj.RMK = order.comments
  obj.SID = user.SID
  obj.FC = order.fixingEventCode
  obj.FN = order.fixingEvent
  obj.FT = order.fixingEventTime
  obj.CTID = order.CTID
  obj.MD = -1
  obj.FD = fixingDate,
    obj.OrderNo = order.orderNo
  //console.log("obj"+JSON.stringify(obj));
  try {
    if (orderWebsocket && connectionOpen === true) {
      orderWebsocket = orderSocket.getSocket();
      orderWebsocket.send(JSON.stringify(obj));
    } else {
      return false;
    }
  } catch (e) {
    return false;
  }
  return true;
}
